<template>
  <v-menu
    ref="menu1"
    v-model="menu1"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="dateFormatted"
        :label="$i18n.t(label)"
        prepend-inner-icon="mdi-calendar-month"
        placeholder="YYYY-MM"
        @blur="date = parseDate(dateFormatted)"
        v-on="on"
        :rules="rules"
        :dense="dense"
        :append-icon="clear ? 'mdi-refresh' : ''"
        @click:append="unsetMonth"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      no-title
      type="month"
      @input="menu1 = false"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "DatePicker",
  props: {
    value: {
      default: "",
    },
    label: {
      default: "Date",
    },
    dense: {
      default: false,
    },
    clear: {
      default: null,
    },
    rules: {
      default: () => [],
    },
  },
})
export default class DatePicker extends (Vue, Themeable) {
  dateFormatted = null;
  menu1 = false;
  date = "";

  mounted() {
    if (
      this.value == null ||
      this.value == "" ||
      this.value == undefined ||
      (Number.isInteger(this.value) && this.value.toString().length != 6)
    ) {
      return;
    }
    const dateStr = this.value.toString();
    this.dateFormatted =
      dateStr.substring(0, 4) + "-" + dateStr.substring(4, 6);
  }

  @Watch("date")
  onDateChange(val) {
    this.dateFormatted = this.formatDate(val);
    if (val != null && val != "")
      this.$emit("input", this.formatDateToInt(val));
  }

  unsetMonth() {
    this.dateFormatted = null;
    this.$emit("input", null);
  }

  @Watch("value", { immediate: true })
  onValueChange(value) {
    // if (
    //   value === null ||
    //   value === undefined ||
    //   value === "" ||
    //   (Number.isInteger(value) && value.toString().length != 8)
    // ) {
    //   const dateObj = new Date();
    //   const month = dateObj.getUTCMonth() + 1; //months from 1-12
    //   const year = dateObj.getUTCFullYear();
    //   this.dateFormatted = year + "-" + (month < 10 ? "0" + month : month);
    //   return;
    // }
    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return;
    }

    if (value.toString().length == 6) {
      const dateStr = this.value.toString();
      this.dateFormatted =
        dateStr.substring(0, 4) + "-" + dateStr.substring(4, 6);
    } else {
      const dateStr = value.toString();
      this.dateFormatted =
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4);
    }
  }

  formatDateToInt(date) {
    if (!date) return null;
    const [year, month, day] = date.split("-");
    return parseInt(`${year}${month}${day}`);
  }

  formatDate(date) {
    if (!date) return null;
    const [year, month] = date.split("-");
    return `${year}-${month}`;
  }

  parseDate(date) {
    if (!date) return null;

    const [year, month] = date.split("-");
    return `${year}-${month.padStart(2, "0")}`;
  }
}
</script>
